module.exports = __webpack_public_path__ + "c30d3bfb36c24be44534863d4fce7242.jpg";